import { call, put, takeLatest } from 'redux-saga/effects'
import * as attendanceApi from '../apiModules/attendance'
import * as attendanceModule from '../modules/attendance'
import { navigate } from '@reach/router'

function* createAttendanceProofReview({ payload }) {
  try {
    const createdAttendanceLog = yield call(attendanceApi.createAttendanceProofReview, payload)
    yield put(attendanceModule.createAttendanceProofReviewSuccess(createdAttendanceLog))

    navigate(`/dashboard/attendance/proofs`)
  } catch (err) {
    yield put(attendanceModule.createAttendanceProofReviewFailure(err.response.data))
  }
}

function* createParticipantAttendance({ payload }) {
  try {
    const createdAttendanceLog = yield call(attendanceApi.createParticipantAttendance, payload)
    yield put(attendanceModule.createParticipantAttendanceSuccess(createdAttendanceLog))
  } catch (err) {
    yield put(attendanceModule.createParticipantAttendanceFailure(err.response.data))
  }
}

function* fetchAttendanceProofs({ payload }) {
  try {
    const response = yield call(attendanceApi.fetchAttendanceProofs, payload)
    const result = { ...response, forceRefresh: payload.forceRefresh }
    yield put(attendanceModule.fetchAttendanceProofsSuccess(result))
  } catch (err) {
    yield put(attendanceModule.fetchAttendanceProofsFailure(err.response.data))
  }
}

function* fetchParticipantAttendance({ payload }) {
  try {
    const response = yield call(attendanceApi.fetchParticipantAttendance, payload)
    const result = { ...response, forceRefresh: payload.forceRefresh }
    yield put(attendanceModule.fetchParticipantAttendanceSuccess(result))
  } catch (err) {
    yield put(attendanceModule.fetchParticipantAttendanceFailure(err.response.data))
  }
}

function* fetchParticipantAttendances({ payload }) {
  try {
    const response = yield call(attendanceApi.fetchParticipantAttendances, payload)
    yield put(attendanceModule.fetchParticipantAttendancesSuccess(response))
  } catch (err) {
    yield put(attendanceModule.fetchParticipantAttendancesFailure(err.response.data))
  }
}

function* importAttendancesProof({ payload }) {
  try {
    const formDataVals = new FormData()

    Object.keys(payload).map(value => {
      if (payload[value]) {
        formDataVals.append(value, payload[value])
      }
    })

    const { data } = yield call(attendanceApi.importAttendancesProof, formDataVals)
    yield put(attendanceModule.importAttendancesProofSuccess({ data }))

    navigate(`/dashboard/attendance/upload-proof?importedProof=success`)
  } catch (err) {
    const errorMessage = err.response.data
    yield put(attendanceModule.importAttendancesProofFailure({ errorMessage, data: payload }))
  }
}

function* importParticipantAttendances({ payload }) {
  try {
    const response = yield call(attendanceApi.importParticipantAttendances, payload)
    yield put(attendanceModule.importParticipantAttendancesSuccess(response))

    navigate(`/dashboard/participants?importedAttendance=success`)
  } catch (err) {
    yield put(attendanceModule.importParticipantAttendancesFailure(err.response.data))
  }
}

function* updateParticipantAttendance({ payload }) {
  try {
    yield call(attendanceApi.updateParticipantAttendance, payload)
    yield put(attendanceModule.updateParticipantAttendanceSuccess(payload))
  } catch (err) {
    yield put(attendanceModule.updateParticipantAttendanceFailure(err.response.data))
  }
}

export const attendanceSagas = [
  takeLatest(attendanceModule.CREATE_ATTENDANCE_PROOF_REVIEW, createAttendanceProofReview),
  takeLatest(attendanceModule.CREATE_PARTICIPANT_ATTENDANCE, createParticipantAttendance),
  takeLatest(attendanceModule.FETCH_ATTENDANCE_PROOFS, fetchAttendanceProofs),
  takeLatest(attendanceModule.FETCH_PARTICIPANT_ATTENDANCE, fetchParticipantAttendance),
  takeLatest(attendanceModule.FETCH_PARTICIPANT_ATTENDANCES, fetchParticipantAttendances),
  takeLatest(attendanceModule.IMPORT_ATTENDANCES_PROOF, importAttendancesProof),
  takeLatest(attendanceModule.IMPORT_PARTICIPANT_ATTENDANCES, importParticipantAttendances),
  takeLatest(attendanceModule.UPDATE_PARTICIPANT_ATTENDANCE, updateParticipantAttendance)
]
